<template>
  <div>

    <div class="columns">
      <div class="column is-narrow">

         <div class="sidebar-page">
      <!-- <section class="sidebar-layout">
        <o-sidebar position="static" :fullheight="true" :expand-on-hover="true" :reduce="true" open>
          <img width="128" src="https://avatars2.githubusercontent.com/u/66300512?s=200&v=4" alt="Lightweight UI components for Vue.js" />
          <section style="padding: 1em">
            <p class="title is-6"> 
              <span class="icon is-small has-text-warning">
                <i class="fas fa-chess-rook"></i>
              </span>
              <span>Acquisition</span>
            </p>
            <h5 class="has-text-grey has-text-weight-semibold">Example 1</h5>
            <h5 class="has-text-grey has-text-weight-semibold">Example 1</h5>
            <h5 class="has-text-grey has-text-weight-semibold">Example 1</h5>
          </section>
        </o-sidebar>


      </section> -->
    </div>
      </div>

      <div class="column">
        <section class="section">
          <button class="button is-small">
            <span class="icon">
              <i class="fas fa-arrow-left"></i>
            </span>
            <span>Prospects</span>
          </button>

          <section class="section">

            <div class="columns is-vcentered">
              <div class="column is-two-thirds">

                <p class="title is-bold">
                  Jeremy Thomas
                  <span class="tag is-medium">Prospect</span>
                </p>
                <p class="subtitle">jgthms@gmail.com</p>

              </div>
              <div class="column is-one-third">
                <div class="buttons is-right">
                  <button class="button is-small">
                    <span class="icon is-small">
                      <i class="fas fa-trash fa-sm"></i>
                    </span>
                    <span>Delete</span>
                  </button>
                </div>
              </div>
            </div>
          <br>




      <o-tabs v-model="activeTab" :multiline="multiline">
        <o-tab-item value="0" label="Overview">
          <br>
          <p class="tag is-medium">Portfolio</p>
          <hr class="bumpup">


          <div class="columns">
            <div class="column is-narrow">
              <p class="has-text-grey-light has-text-weight-semibold is-size-6">Portfolio Total Value </p>
              <p class="title is-4">$14,376,897 USD</p>
            </div>
            <div class="column is-narrow">
              <p class="has-text-grey-light has-text-weight-semibold is-size-6">Legal Entities</p>
              <p class="title is-4">78</p>
            </div>
            <div class="column is-narrow">
              <p class="has-text-grey-light has-text-weight-semibold is-size-6">Accounts</p>
              <p class="title is-4">896</p>
            </div>
            <div class="column is-narrow">
              <p class="has-text-grey-light has-text-weight-semibold is-size-6">Holdings</p>
              <p class="title is-4">4,675</p>
            </div>
          </div>

          <div class="buttons">
            <button class="button is-small">
              <span class="icon is-small">
                <i class="fas fa-sort-amount-down-alt"></i>
              </span>
              <span>Explore Holdings</span>
            </button>
            <button class="button is-small">
              <span class="icon is-small">
                <i class="fas fa-file-alt"></i>
              </span>
              <span>Generate Report</span>
            </button>
          </div>


          <br>



          <p class="tag is-medium">Values</p>
          <hr class="bumpup">
          <div class="tags are-large ">
            <span class="tag is-warning is-light">Planet Protector</span>
            <span class="tag is-warning is-light">Health Defender</span>
            <span class="tag is-warning is-light">Racial Equity Advocate</span>
          </div>

          <div class="buttons">
            <button class="button is-small">
              <span class="icon is-small">
                <i class="fas fa-edit"></i>
              </span>
              <span>Edit Values</span>
            </button>
            <button class="button is-small">
              <span class="icon is-small">
                <i class="fas fa-sliders-h"></i>
              </span>
              <span>Fine Tune Values</span>
            </button>
          </div>



          <br>

          <p class="tag is-medium">Groups</p>

          <hr class="bumpup">

          <div class="columns">
            <div class="column is-2">
              <p>
                <span class="icon">
                  <i class="fas fa-users"></i>
                </span>
                <span class="has-text-weight-semibold">Household</span >
              </p>
            </div>
            <div class="column">
              <p class="tags are-large">
                <span class="tag is-info is-light">Thomas Family Household</span>
              </p>
            </div>
          </div>

          <div class="columns">
            <div class="column is-2">
              <p>
                <span class="icon">
                  <i class="fas fa-money-bill-wave"></i>
                </span>
                <span class="has-text-weight-semibold">Beneficiary</span >
              </p>

            </div>
            <div class="column">
              <p class="tags are-large">
                <span class="tag is-info is-light">Thomas Trust</span>
              </p>
            </div>
          </div>


          <div class="buttons">
            <button class="button is-small">
              <span class="icon is-small">
                <i class="fas fa-download"></i>
              </span>
              <span>Add to Existing Group</span>
            </button>
            <button class="button is-small">
              <span class="icon is-small">
                <i class="fas fa-user-plus"></i>
              </span>
              <span>Create New Group</span>
            </button>
          </div>



        </o-tab-item>

        <o-tab-item :value="1" label="Values">
          Lorem <br />
          ipsum <br />
          dolor <br />
          sit <br />
          amet.
        </o-tab-item>

        <o-tab-item value="2" :visible="showBooks" label="Accounts">
          What light is light, if Silvia be not seen? <br />
          What joy is joy, if Silvia be not by— <br />
          Unless it be to think that she is by <br />
          And feed upon the shadow of perfection? <br />
          Except I be by Silvia in the night, <br />
          There is no music in the nightingale.
        </o-tab-item>

        <o-tab-item value="3" label="Groups" >
          <br>


          <div class="columns ml-6 mr-6">
            <div class="column">
              <p class="tag ">
                <span class="tag is-medium">Thomas Family Household</span>
              </p>
            </div>
            <div class="column is-narrow has-text-right">
              <p class=" has-background-white title is-5 pr-3 pl-3">
                $5,890,245 USD
              </p>
            </div>
          </div>
          <div class="lightbox">

            <div class="columns">
              <div class="column">
                <p class="has-text-grey-light has-text-weight-semibold is-size-6">
                  Person
                </p>
              </div>
              <div class="column is-1">
                <p class="has-text-grey-light has-text-weight-semibold is-size-6">
                  Holdings
                </p>
              </div>
              <div class="column is-3">
                <p class="has-text-grey-light has-text-weight-semibold is-size-6">
                  Value
                </p>
              </div>
            </div>

            <div class="columns">
              <div class="column">
                <p class="tag is-large is-info is-light has-text-weight-bold">
                  Jeremy Thomas (this person)
                </p>
              </div>
              <div class="column is-1">
                <p class="has-text-weight-semibold is-size-6">
                  4,658
                </p>
              </div>
              <div class="column is-3">
                <p class="has-text-weight-semibold is-size-6">
                  $2,349,325
                </p>
              </div>
            </div>

            <div class="columns">
              <div class="column">
                <p class="tag is-large is-info is-light has-text-weight-bold">
                  Helen Thomas 
                </p>
              </div>
              <div class="column is-1">
                <p class="has-text-weight-semibold is-size-6">
                  4,658
                </p>
              </div>
              <div class="column is-3">
                <p class="has-text-weight-semibold is-size-6">
                  $2,349,325
                </p>
              </div>
            </div>

            <div class="columns">
              <div class="column">
                <p class="is-size-5 has-text-weight-bold">
                  Joint Account
                </p>
              </div>
              <div class="column is-1">
                <p class="has-text-weight-semibold is-size-6">
                  658
                </p>
              </div>
              <div class="column is-3">
                <p class="has-text-weight-semibold is-size-6">
                  $49,325
                </p>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <button class="button">
                  <span class="icon is-small">
                    <i class="fas fa-plus"></i>
                  </span>
                  <span>Add Person</span>
                </button>

              </div>


            </div>

            <hr>

            <div class="columns">
              <div class="column">
                <p class="is-size-5 has-text-weight-bold">
                  Total
                </p>
              </div>
              <div class="column is-1">
                <p class="has-text-weight-semibold is-size-6">
                  9,658
                </p>
              </div>
              <div class="column is-3">
                <p class="has-text-weight-semibold is-size-6">
                  $5,349,325
                </p>
              </div>
            </div>
          </div><!-- lightbox -->

          <br>
          <br>

          <div><!-- overall component for displaying joint account groupings -->
            <div class="columns ml-6 mr-6">
              <div class="column">
                <p class="tag ">
                  <span class="tag is-medium">Thomas Family Household</span>
                </p>
              </div>
              <div class="column is-narrow has-text-right">
                <p class=" has-background-white title is-5 pr-3 pl-3">
                  $5,890,245 USD
                </p>
              </div>
            </div>

            <div class="lightbox">

              <div class="columns">
                <div class="column">
                  <p class="has-text-grey-light has-text-weight-semibold is-size-6">
                    Person
                  </p>
                </div>
                <div class="column is-1">
                  <p class="has-text-grey-light has-text-weight-semibold is-size-6">
                    Holdings
                  </p>
                </div>
                <div class="column is-3">
                  <p class="has-text-grey-light has-text-weight-semibold is-size-6">
                    Value
                  </p>
                </div>
              </div>

              <div class="columns">
                <div class="column">
                  <p class="tag is-large is-info is-light has-text-weight-bold">
                    Jeremy Thomas (this person)
                  </p>
                </div>
                <div class="column is-1">
                  <p class="has-text-weight-semibold is-size-6">
                    4,658
                  </p>
                </div>
                <div class="column is-3">
                  <p class="has-text-weight-semibold is-size-6">
                    $2,349,325
                  </p>
                </div>
              </div>

              <div class="columns">
                <div class="column">
                  <p class="tag is-large is-info is-light has-text-weight-bold">
                    Helen Thomas 
                  </p>
                </div>
                <div class="column is-1">
                  <p class="has-text-weight-semibold is-size-6">
                    4,658
                  </p>
                </div>
                <div class="column is-3">
                  <p class="has-text-weight-semibold is-size-6">
                    $2,349,325
                  </p>
                </div>
              </div>

              <div class="columns">
                <div class="column">
                  <p class="is-size-5 has-text-weight-bold">
                    Joint Account
                  </p>
                </div>
                <div class="column is-1">
                  <p class="has-text-weight-semibold is-size-6">
                    658
                  </p>
                </div>
                <div class="column is-3">
                  <p class="has-text-weight-semibold is-size-6">
                    $49,325
                  </p>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <button class="button">
                    <span class="icon is-small">
                      <i class="fas fa-plus"></i>
                    </span>
                    <span>Add Person</span>
                  </button>

                </div>


              </div>

              <hr>

              <div class="columns">
                <div class="column">
                  <p class="is-size-5 has-text-weight-bold">
                    Total
                  </p>
                </div>
                <div class="column is-1">
                  <p class="has-text-weight-semibold is-size-6">
                    9,658
                  </p>
                </div>
                <div class="column is-3">
                  <p class="has-text-weight-semibold is-size-6">
                    $5,349,325
                  </p>
                </div>
              </div>
            </div><!-- lightbox -->
          </div>


        </o-tab-item>
        <o-tab-item value="4" label="Connections" >
          Nunc nec velit nec libero vestibulum eleifend. Curabitur pulvinar congue luctus. Nullam hendrerit iaculis augue vitae ornare. Maecenas vehicula pulvinar tellus, id sodales
          felis lobortis eget.
        </o-tab-item>
        <o-tab-item value="5" label="Documents">
  <div class="documents-tab">
      <button class="button is-primary" @click="showRequestModal = true">Generate Document Request Link</button>

    <div v-if="showRequestModal" class="modal is-active">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Generate Document Request Link</p>
          <button class="delete" @click="showRequestModal = false"></button>
        </header>
        <section class="modal-card-body">
          <div v-for="item in documentRequestList" :key="item.name">
            <label>
              <input type="checkbox" v-model="item.checked">
              {{ item.name }}
            </label>
          </div>
          <br>
          <label>Select Survey:</label>
          <select v-model="selectedSurvey">
            <option value="annual review">YourStake Annual Review</option>
            <option value="new prospect">YourStake New Prospect</option>
            <option value="custom">My Custom Survey</option>
          </select>
          <br>
          <label>
            <input type="checkbox" v-model="includeValuesQuestionnaire">
            Include Values Questionnaire
          </label>
          <br>
          <label>
            <input type="checkbox" v-model="includeRiskQuestionnaire">
            Include Risk Questionnaire
          </label>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-success" @click="generateRequestLink">Generate Link</button>
          <button class="button" @click="showRequestModal = false">Cancel</button>
        </footer>
      </div>
    </div>

    <div v-if="requestLink" class="request-link-section">
      <h3 class="title is-5">Document Request Link</h3>
      <p>{{ requestLink }}</p>
      <h3 class="title is-5">Document Request Progress</h3>
      <div class="progress-tracker">
        <div :class="{'completed': progressStage >= 1}">
          <span>1. Link Generated</span>
          <span v-if="progressStage >= 1" class="icon">
            <i class="fas fa-check"></i>
          </span>
        </div>
        <div :class="{'completed': progressStage >= 2}">
          <span>2. Client Opened Link</span>
          <span v-if="progressStage >= 2" class="icon">
            <i class="fas fa-check"></i>
          </span>
        </div>
        <div :class="{'completed': progressStage >= 3}" @click="updateProgress">
          <span>3. Some documents submitted</span>
          <span v-if="progressStage >= 3" class="icon">
            <i class="fas fa-check"></i>
          </span>
        </div>
        <div :class="{'completed': progressStage >= 4}">
          <span>4. All documents submitted</span>
          <span v-if="progressStage >= 4" class="icon">
            <i class="fas fa-check"></i>
          </span>
        </div>
      </div>
    </div>
    <br>
    <br>
    <br>
    <br>
    <button class="button is-light" @click="toggleDrawer">Uploaded Documents</button>

    <div v-show="drawerOpen" class="drawer">
      <h2 class="title is-4 uploaded-documents-title">Uploaded Documents</h2>
      <div class="filters">
        <label for="sort">Sort by:</label>
        <select id="sort" v-model="sortOption">
          <option value="date">Upload Date</option>
          <option value="type">Document Type</option>
        </select>

        <label for="filter">Filter by type:</label>
        <select id="filter" v-model="filterType">
          <option value="">All</option>
          <template v-for="type in documentTypes">
            <option :key="type" :value="type">{{ type }}</option>
          </template>
        </select>
      </div>

      <div v-if="filteredDocuments.length">
        <ul>
          <li v-for="doc in filteredDocuments" :key="doc.id">
            <span class="document-name"><strong>{{ doc.name }}</strong></span> - 
            <span class="document-date"><em>{{ formatDate(doc.uploadDate) }}</em></span>
          </li>
        </ul>
      </div>
      <div v-else>
        <p>No documents available.</p>
      </div>
    </div>
  </div>
</o-tab-item>







        <o-tab-item value="6" label="Reports" >

          <br>

          <p class="tags pr-6 pl-6">
            <span class="tag is-large">
              Generate a Report
            </span>
          </p>
          <div class="lightbox-shallow">
            <div class="columns">
              <div class="column is-half">
              </div>
              <div class="column is-half">
                <div class="content has-text-weight-medium is-size-5">
                  <p>What will be included in the Report:</p>
                  <p>
                    <span class="has-text-primary">182</span >
                    <span class="has-text-grey-light">/ 452</span>
                    Accounts
                  </p>
                  <p>
                    <span class="has-text-primary">2,097</span >
                    <span class="has-text-grey-light">/ 5,421</span>
                    Holdings
                  </p>
                  <p>
                    <span class="has-text-primary">46.7%</span >
                    <span class="has-text-grey-light">/ 100%</span>
                    Ownership
                  </p>
                  <p>
                    <span class="has-text-primary">$5,245,145 USD</span >
                    <span class="has-text-grey-light">/ $11,242,647 USD</span>
                    Value
                  </p>
                </div><!-- text content-->
                <input class="input mb-3" placeholder="Name">

                <div class="buttons">
                  <a class="button is-medium is-primary">
                    Generate Report
                  </a>
                  <a class="button is-medium">
                    Save as Template
                  </a>
                </div>
              </div><!-- half column-->
            </div>
          </div>

        </o-tab-item>
      </o-tabs>



          <br>

          </section>
        </section>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      documents: [], // Fetch this from your data source
      sortOption: 'date',
      filterType: '',
      documentTypes: ['Tax', 'Investment', 'Insurance', 'Estate', 'Income', 'Misc'], // Updated document types
      documentRequestList: [
        { name: "Bank Statements", checked: true},
        { name: "Investment Statements", checked: true},
        { name: "Insurance Statements", checked: true},
        { name: "1040 Tax Return", checked: true, files: [] },
        { name: "Social Security Benefit Estimate Statement", checked: true},
        { name: "Health Proxy", checked: true},
        { name: "Will", checked: true},
        { name: "Power of Attorney", checked: true},
        { name: "Mortgage Statements", checked: false },
        { name: "Loan Statements", checked: false },
        { name: "W-2", checked: false },
      ],
      showRequestModal: false,
      requestedDocuments: [],
      selectedSurvey: 'annual review',
      includeValuesQuestionnaire: false,
      includeRiskQuestionnaire: false,
      requestLink: '',
      progressStage: 0,
      drawerOpen: false,
    };
  },
  computed: {
    filteredDocuments() {
      let docs = this.documents.filter(doc => 
        !this.filterType || doc.type === this.filterType
      );
      if (this.sortOption === 'date') {
        docs.sort((a, b) => new Date(b.uploadDate) - new Date(a.uploadDate));
      } else if (this.sortOption === 'type') {
        docs.sort((a, b) => a.type.localeCompare(b.type));
      }
      return docs;
    }
  },
  methods: {
    updateProgress() {
      this.progressStage = 3;
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString();
    },
    generateRequestLink() {
      const baseUrl = 'https://yourstake.org/request-documents';
      const params = new URLSearchParams();
      params.append('documents', this.requestedDocuments.join(','));
      params.append('survey', this.selectedSurvey);
      params.append('includeValues', this.includeValuesQuestionnaire);
      params.append('includeRisk', this.includeRiskQuestionnaire);
      this.requestLink = `${baseUrl}?${params.toString()}`;
      this.showRequestModal = false;
      this.progressStage = 1; // Initially mark as "Opened"
    },
    toggleDrawer() {
      this.drawerOpen = !this.drawerOpen;
    },
  },
  mounted() {
    const today = new Date().toISOString().split('T')[0];
    // Set documents data with today's date
    this.documents = [
      { id: 1, name: 'sample-1040-2024', type: 'Tax', uploadDate: today },
      { id: 2, name: 'accountStatement.1', type: 'Investment', uploadDate: today },
      { id: 3, name: 'sample-new-fidelity-acnt-stmt', type: 'Investment', uploadDate: today },
      { id: 4, name: 'health-proxy-webb', type: 'Estate', uploadDate: today },
      { id: 5, name: 'sample-bank-statement', type: 'Income', uploadDate: today },
    ];
  },
};
</script>






<style scoped>
  .page {
    /* Center the page on the screen */
    border: 1px solid #000;
    /* Define a border so you can see the page's dimensions */
    background-color: #fff;
    /* Set the background color to white */
    box-sizing: border-box;
    /* Include padding and border in element's total width and height */
    overflow: visible;
  }
  .pagewidth {
    max-width: 70em;
    min-width: 50em;
    margin: auto;
  }
  .pagecontent {
    padding: 0.5in;
    /* Provide a bit of space around the content */
  }
  .niceblue {
    background-color: #0a0b4f;
    background-image: linear-gradient(141deg, #1e4182 0, #0a0b4f 71%, #20217e 100%);
    color: white;
  }
  .pro-blue {
    background-color: rgb(15, 7, 43);
    background-image: linear-gradient(141deg, rgb(15, 7, 43), rgb(33, 13, 100), rgb(18, 9, 53));
    color: white;
  }
  .niceblue>p,
  .niceblue>.title,
  .niceblue>.subtitle {
    color: white;
  }
  .highlightbox {
    border: 2px solid #3C60E2;
    border-radius: 5px;
    padding: 10px;
  }
  .paperwidth {
    margin: auto;
    width: 8.5in;
  }
  .stickysection {
    position: sticky;
    z-index: 10;
    border: 2px solid white;
    border-radius: 5px;
    background-color: inherit;
  }
  .pagewidth {
    max-width: 80em;
    min-width: 50em;
  }
  .greentop {
    border-top: 3px solid green;
  }
  .yellowtop {
    margin-top: 1.5em;
    border-top: 3px solid yellow;
  }
  .redtop {
    border-top: 3px solid red;
  }
  .tabs.color-tips  li {
    margin-right: .5em;
  }
  .tabs.color-tips  a {
    border-top: 3px solid green;
  }
  .sticky-bottom {
    position: fixed;
    bottom: 0;
    width: 100%;
}
.primary-top {
  margin-top: 1em;
}
.moneysaved {
  border: 3px solid #3C60E2;
  border-radius: 9px;
  padding: .5em;
  padding-left: 2em;
}
.whitebackground {
  background-color: white;
  color: black;
}
.off-white-background {
  background-color: whitesmoke;
  color: black;
}
.chatborder {
  border: 3px solid purple;
  border-radius: 9px;
  padding: .5em;
}
.tightcolumns > .columns, .tightcolumns > .columns > .column {
  margin: 0;
  padding: 0
}
.smile {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.smile .button:nth-child(1) {
  align-self: flex-start;
}
.smile .button:nth-child(2) {
  align-self: center; 
}
.smile .button:nth-child(3) {
  align-self: center;
}
.smile .button:nth-child(4) {
  align-self: flex-start;
}
.maxwidth {
  max-width: 30em;
}
#upside-tabs {
  display: flex;
  flex-direction: column-reverse;
}
.bumpup {
  margin-top: -1em;
}
.greybackground {
  background-color: 	#FAF9F6;
}
.lightbox {
  border: 3px solid rgb(200,203,209);
  padding: 1.5em;
  border-radius: 15px;
  margin-top: -2.25em;
}
.lightbox-shallow {
  border: 3px solid rgb(200,203,209);
  padding: 1.5em;
  border-radius: 15px;
  margin-top: -2.75em;
}
.documents-tab {
  padding: 1em;
}

.request-link-section {
  margin-bottom: 1.5em;
}

.drawer {
  margin-top: 1.5em;
  border-top: 1px solid #ddd;
  padding-top: 1em;
}

.filters {
  display: flex;
  gap: 1em;
  margin-bottom: 1em;
}

ul {
  list-style: none;
  padding: 0;
}

li {
  padding: 0.5em 0;
  border-bottom: 1px solid #ddd;
}

.document-name {
  font-weight: bold;
}

.document-date {
  font-style: italic;
}

.modal-card {
  width: 600px;
}

.progress-tracker {
  display: flex;
  justify-content: space-between;
  margin-top: 1em;
}

.progress-tracker > div {
  flex: 1;
  text-align: center;
  padding: 0.5em;
  border: 1px solid #ccc;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.progress-tracker > div.completed {
  background-color: #d4edda;
  border-color: #c3e6cb;
  color: #155724;
}

.icon {
  margin-left: 0.5em;
  color: #155724;
}
  </style>